import Vue from 'vue'
import { Toast } from 'cube-ui'

let Hub = new Vue({
  data () {
    return {
      user: {},
      firendOne: {},
      firendMuit: [],
      mainToast: null,
      commonUrl: '',
      isToastShow: false,
      allowBack: true
    }
  }
})

function ToastCeate (title, icon, setTime) {
  let time = setTime || 1000
  let mask = false
  if (icon == 'loading') {
    time = 0
    mask = true
  }
  let toastAxios = Toast.$create({
    txt: title,
    type: icon,
    time: time,
    mask: mask
  })
  return toastAxios
}

export {
  Hub,
  ToastCeate
}



// WEBPACK FOOTER //
// ./src/common/js/hub.js